<script setup lang="ts">
  import LabResult from '@/components/projectDetail/LabResultsDrawer/LabResult.vue'
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDebounceComputed } from '@/composables/useDebounceComputed'
  import { useSelectableColumns } from '@/composables/useSelectableColumns'
  import NoDataAvailableText from '@/components/projectDetail/components/NoDataAvailableText.vue'

  const giPointStore = useGIPointsStore()
  const boreholeSampleObservationStore = useBoreholeSampleObservationStore()
  const { selectableColumns } = storeToRefs(boreholeSampleObservationStore)
  const searchQuery = useDebounceComputed('', 300)
  const { selectedColumnsDisplay } = useSelectableColumns(1000)

  const shownGIPoints = computed(() => {
    if (!searchQuery.value || searchQuery.value === '') {
      return giPointStore.giPointsWithBorehole
    }
    return giPointStore.giPointsWithBorehole.filter((giPoint) => {
      return giPoint.properties.location_id.toLowerCase().includes(searchQuery.value.toLowerCase())
    })
  })
  const hasGIPoints = computed(() => shownGIPoints.value.length > 0)
</script>

<template>
  <div style="max-height: 91%" class="overflow-y-auto">
    <v-container class="pt-2 pb-0 px-2 sticky bg-white">
      <v-row no-gutters>
        <v-col cols="3">
          <v-text-field
            class="mr-2"
            v-model="searchQuery"
            color="primary"
            append-inner-icon="mdi-magnify"
            density="comfortable"
            label="Search..."
            hide-details
            single-line
            clearable
          />
        </v-col>
        <v-col cols="9">
          <v-select
            v-model="selectedColumnsDisplay"
            multiple
            clearable
            chips
            closable-chips
            label="Lab result column selection"
            :items="selectableColumns"
            filled
            density="comfortable"
            color="primary"
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
    <NoDataAvailableText>
      {{
        hasGIPoints
          ? 'Please expand the list to view the lab results for each borehole.'
          : 'There are no boreholes available.'
      }}
    </NoDataAvailableText>
    <v-list class="mt-0 pb-10">
      <v-virtual-scroll :items="shownGIPoints" :max-height="630">
        <template v-slot:default="{ item: giPoint }">
          <LabResult :gi-point="giPoint" :key="giPoint.id" />
        </template>
      </v-virtual-scroll>
    </v-list>
  </div>
</template>

<style scoped>
  .sticky {
    position: sticky;
    top: 0;
    z-index: 1000;
  }
</style>
